import styled from 'styled-components';

export const FormWrapper = styled.div`
  width: 250px;
  margin: auto;
  width: 50%;
  padding: 10px;
`;

export const Label = styled.div`
  text-align: center;
  color: #000;
  font-weight: 'bold';
`;
